<template lang="pug">
div
  .menu-section(v-for='x in menuItems')
    .section-name {{ x.name }}
    router-link.side-menu-item(v-for='i in x.items', :to='i.to', :key='i.to')
      i.mat-icon {{i.icon}}
      span {{ i.name }}
</template>

<script>
export default {
  data ( ) {
    return {
      menuItems: [
        {
          name: 'Menu',
          items: [
            { to: '/user/overview', name: 'Overview', icon: 'all_out' },
            { to: '/user/requests', name: 'Requests', icon: 'assignment' },
            { to: '/user/orders', name: 'Orders', icon: 'assignment_turned_in' },
            { to: '/user/billing', name: 'Billing', icon: 'payment' },
            { to: '/user/address_book', name: 'Address Book', icon: 'import_contacts' },
            { to: '/user/settings', name: 'Settings', icon: 'settings' },
          ],
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/UserNavigation.vue